import {asyncScheduler} from 'rxjs';
import {map, throttleTime} from 'rxjs/operators';
import {toUiMsg$} from '@/ui';
import {assets$} from './assets';
import {Assets} from '@/types/assets';

export interface UAssets {
  type: 'assets';
  data: {
    assets: Assets;
  };
}

export function subscribeAssets() {
  assets$
    .pipe(
      throttleTime(300, asyncScheduler, {leading: false, trailing: true}), // 总资产更新频率太高会影响性能
      map((assets: Assets) => ({type: 'assets', data: {assets}} as UAssets))
    )
    .subscribe((msg) => toUiMsg$.next(msg));
}
